import { render, staticRenderFns } from "./VaccinationAnalysis.vue?vue&type=template&id=54f1b8e2&"
import script from "./VaccinationAnalysis.vue?vue&type=script&lang=ts&"
export * from "./VaccinationAnalysis.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports